import { render, staticRenderFns } from "./eduMenu.vue?vue&type=template&id=4ef60330&"
import script from "./eduMenu.vue?vue&type=script&lang=js&"
export * from "./eduMenu.vue?vue&type=script&lang=js&"
import style0 from "./eduMenu.vue?vue&type=style&index=0&id=4ef60330&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports